<div fxLayout fxLayoutGap="10px" fxLayoutAlign="start center">
  <img *ngIf="permissions.inbox" src="/assets/iconography/user-management/products/inbox-active.svg" />
  <img *ngIf="!permissions.inbox" src="/assets/iconography/user-management/products/inbox-inactive.svg" />

  <img *ngIf="permissions.properties" src="/assets/iconography/user-management/products/properties-active.svg" />
  <img *ngIf="!permissions.properties" src="/assets/iconography/user-management/products/properties-inactive.svg" />

  <img *ngIf="permissions.calendar" src="/assets/iconography/user-management/products/calendar-active.svg" />
  <img *ngIf="!permissions.calendar" src="/assets/iconography/user-management/products/calendar-inactive.svg" />

  <img *ngIf="permissions.gx" src="/assets/iconography/user-management/products/gx-active.svg" />
  <img *ngIf="!permissions.gx" src="/assets/iconography/user-management/products/gx-inactive.svg" />

  <img *ngIf="permissions.ops" src="/assets/iconography/user-management/products/ops-active.svg" />
  <img *ngIf="!permissions.ops" src="/assets/iconography/user-management/products/ops-inactive.svg" />

  <img *ngIf="permissions.metrics" src="/assets/iconography/user-management/products/metrics-active.svg" />
  <img *ngIf="!permissions.metrics" src="/assets/iconography/user-management/products/metrics-inactive.svg" />

  <img *ngIf="permissions.apps" src="/assets/iconography/user-management/products/apps-active.svg" />
  <img *ngIf="!permissions.apps" src="/assets/iconography/user-management/products/apps-inactive.svg" />

  <img *ngIf="permissions.metrics" src="/assets/iconography/user-management/products/metrics-active.svg" />
  <img *ngIf="!permissions.metrics" src="/assets/iconography/user-management/products/metrics-inactive.svg" />

  <img *ngIf="permissions.direct" src="/assets/iconography/user-management/products/direct-active.svg" />
  <img *ngIf="!permissions.direct" src="/assets/iconography/user-management/products/direct-inactive.svg" />

  <img
    *ngIf="permissions.smartlocks_dashboard"
    src="/assets/iconography/user-management/products/nav-devices-active.svg" />
  <img
    *ngIf="!permissions.smartlocks_dashboard"
    src="/assets/iconography/user-management/products/nav-devices-inactive.svg" />
</div>
